import { motion } from "framer-motion";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useReducedMotion } from "@/hooks/useReducedMotion";

// Mode-switch routes (sidebar navigation) - NO progress bar
const MODE_SWITCH_ROUTES = ['/orders', '/products', '/archive', '/delivery', '/dashboard', '/settings'];

export function NavigationProgress() {
  const [isNavigating, setIsNavigating] = useState<boolean>(false);
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const shouldReduceMotion = useReducedMotion();

  useEffect(() => {
    const pathname = location.pathname;
    const prevPath = prevPathRef.current;
    prevPathRef.current = pathname;

    // Check if BOTH current and previous routes are mode-switch routes
    const isCurrentModeSwitch = MODE_SWITCH_ROUTES.some(route => pathname.startsWith(route));
    const isPrevModeSwitch = MODE_SWITCH_ROUTES.some(route => prevPath.startsWith(route));

    // Skip progress bar for mode-switch to mode-switch navigation
    if (isCurrentModeSwitch && isPrevModeSwitch) {
      setIsNavigating(false);
      return;
    }

    setIsNavigating(true);
    const timer = setTimeout(() => {
      setIsNavigating(false);
    }, 250);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Skip entirely for reduced-motion users
  if (!isNavigating || shouldReduceMotion) return null;

  return (
    <motion.div
      className="fixed left-0 right-0 top-0 z-50 h-1 bg-gradient-to-r from-primary via-purple-600 to-primary"
      initial={{ scaleX: 0, originX: 0 }}
      animate={{ scaleX: 1 }}
      exit={{ scaleX: 1, originX: 1 }}
      transition={{ duration: 0.25, ease: "easeInOut" }}
    />
  );
}
